module.exports = __webpack_public_path__ + "img/paragraph-left.75f67c3d.svg";